var _defs, _g, _g2, _g3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEstimate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo-CostCalculator",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #064b93;\n      }\n\n      .st1 {\n        fill: #fff;\n      }\n\n      .st2 {\n        fill: #9776b3;\n      }\n\n      .st3 {\n        fill: #004b93;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo-CostCalculator1",
    "data-name": "Logo-CostCalculator"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1425",
    className: "st0",
    d: "M0,62.3h104v32c0,5.5-4.5,10-10,10H10c-5.5,0-10-4.5-10-10v-32h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1426",
    className: "st2",
    d: "M104,62.3H0V10.3C0,4.8,4.5.3,10,.3h84c5.5,0,10,4.5,10,10v52h0Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.5,82.7c0-6.7,5.1-11.5,12-11.5s6.8,1.3,8.9,3.7l-2.7,2.5c-1.6-1.8-3.6-2.6-6-2.6-4.6,0-8,3.3-8,7.9s3.4,7.9,8,7.9,4.4-.9,6-2.7l2.7,2.6c-2.1,2.4-5.2,3.7-8.9,3.7-6.8,0-12-4.8-12-11.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M51.3,82.7c0-6.6,5.1-11.5,12.1-11.5s12.1,4.9,12.1,11.5-5.1,11.5-12.1,11.5-12.1-4.9-12.1-11.5ZM71.3,82.7c0-4.6-3.4-7.9-7.9-7.9s-7.9,3.3-7.9,7.9,3.4,7.9,7.9,7.9,7.9-3.3,7.9-7.9Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 43.4,
    y: 27,
    width: 8.6,
    height: 8.6,
    rx: 0.6,
    ry: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 26.8,
    y: 27,
    width: 8.6,
    height: 8.6,
    rx: 0.6,
    ry: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 11,
    y: 27,
    width: 8.6,
    height: 8.6,
    rx: 0.6,
    ry: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 43.4,
    y: 42.3,
    width: 8.6,
    height: 8.6,
    rx: 0.6,
    ry: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 26.8,
    y: 42.3,
    width: 8.6,
    height: 8.6,
    rx: 0.6,
    ry: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 11,
    y: 42.3,
    width: 8.6,
    height: 8.6,
    rx: 0.6,
    ry: 0.6
  })), /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    x: 11,
    y: 11.7,
    width: 41,
    height: 8.6,
    rx: 0.6,
    ry: 0.6
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M80,46.6v4.7h-3.4v-4.7c-4.1-.3-8.1-1.6-10.3-3.5l1.9-4.2c2.1,1.7,5.2,2.9,8.4,3.2v-8.4c-4.7-1.1-9.7-2.6-9.7-8.5s3.1-8,9.7-8.7v-4.7h3.4v4.7c3.1.2,6.3,1.1,8.5,2.6l-1.7,4.2c-2.2-1.3-4.6-2-6.8-2.3v8.5c4.7,1.1,9.7,2.6,9.7,8.4s-3.2,8-9.7,8.7ZM76.6,28.6v-7.5c-3,.5-4.2,2-4.2,3.8s1.8,2.9,4.2,3.7ZM84.4,38.3c0-2.1-1.8-3-4.4-3.7v7.4c3.1-.5,4.4-1.9,4.4-3.7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstimate);
export default __webpack_public_path__ + "static/media/Estimate.47fdcda576249173405c07c38720d8b0.svg";
export { ForwardRef as ReactComponent };